"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vars = exports.default = exports.common = exports.Storybook = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = require("react-jss");
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _Theme = require("../../themes/Theme");
var _createPolymorphicComponent = _interopRequireDefault(require("../../utils/createPolymorphicComponent"));
var _defaultProps = _interopRequireDefault(require("../../utils/defaultProps"));
var _getPseudoStyles = _interopRequireDefault(require("../../utils/getPseudoStyles"));
var _getRgbaFromHex = _interopRequireDefault(require("../../utils/getRgbaFromHex"));
var _pickAndRemoveFromObject = _interopRequireDefault(require("../../utils/pickAndRemoveFromObject"));
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
var _excluded = ["as", "className", "disabled", "fill", "filled", "type", "name", "overrides", "outlined", "shadow", "size", "iconSize", "viewBox", "selected", "title", "dropShadow", "buttonHeight", "buttonWidth", "borderWidth"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var common = exports.common = ["height", "width"].concat(_toConsumableArray(_commonProps.defaultCommonProps));
var privateCommon = ["padding"];
var vars = exports.vars = (0, _initVars.default)({
  applied: [].concat(_toConsumableArray(common), privateCommon),
  variables: [{
    key: "borderWidth"
  }, {
    key: "colorsBorderColor"
  }, {
    key: "svgFill"
  }, {
    key: "hoverColor"
  }, {
    key: "selectedBorder"
  }, {
    key: "selectedHover"
  }]
});
var isTypeDefault = function isTypeDefault(type) {
  return type === "default";
};
var TRANSITION_TIME = 300;
var IconButton = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _theme$themeProviderP, _theme$themeProviderP2;
  var _props$as = props.as,
    Element = _props$as === void 0 ? "button" : _props$as,
    className = props.className,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$fill = props.fill,
    fill = _props$fill === void 0 ? null : _props$fill,
    _props$filled = props.filled,
    filled = _props$filled === void 0 ? false : _props$filled,
    _props$type = props.type,
    type = _props$type === void 0 ? "default" : _props$type,
    name = props.name,
    _props$overrides = props.overrides,
    overrides = _props$overrides === void 0 ? {} : _props$overrides,
    _props$outlined = props.outlined,
    outlined = _props$outlined === void 0 ? false : _props$outlined,
    _props$shadow = props.shadow,
    shadow = _props$shadow === void 0 ? "off" : _props$shadow,
    _props$size = props.size,
    size = _props$size === void 0 ? "medium" : _props$size,
    iconSize = props.iconSize,
    _props$viewBox = props.viewBox,
    viewBox = _props$viewBox === void 0 ? "0 0 24 24" : _props$viewBox,
    _props$selected = props.selected,
    selected = _props$selected === void 0 ? false : _props$selected,
    title = props.title,
    dropShadow = props.dropShadow,
    buttonHeight = props.buttonHeight,
    buttonWidth = props.buttonWidth,
    _props$borderWidth = props.borderWidth,
    borderWidth = _props$borderWidth === void 0 ? 1 : _props$borderWidth,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = (0, _reactJss.useTheme)();
  var _getColors = getColors(type, theme.colors, fill, [_Theme.PlatformId.streamfans, _Theme.PlatformId.streamate].includes(theme === null || theme === void 0 || (_theme$themeProviderP = theme.themeProviderProps) === null || _theme$themeProviderP === void 0 ? void 0 : _theme$themeProviderP.platformId), theme === null || theme === void 0 || (_theme$themeProviderP2 = theme.themeProviderProps) === null || _theme$themeProviderP2 === void 0 ? void 0 : _theme$themeProviderP2.themeMode),
    baseBorder = _getColors.baseBorder,
    baseSvg = _getColors.baseSvg,
    baseHover = _getColors.baseHover,
    selectedBorder = _getColors.selectedBorder,
    selectedSvg = _getColors.selectedSvg,
    selectedHover = _getColors.selectedHover;
  var classes = useStyles(vars.useVars(_objectSpread(_objectSpread(_objectSpread({
    size: size,
    height: buttonHeight,
    width: buttonWidth,
    padding: typeof size === "number" && size <= 16 ? 6 : theme.spacing.base
  }, (0, _pickAndRemoveFromObject.default)(otherProps, common)), props), {}, {
    borderWidth: borderWidth,
    colorsBorderColor: selected ? selectedBorder : baseBorder,
    svgFill: selected ? selectedSvg : baseSvg,
    hoverColor: selected ? selectedHover : baseHover,
    selectedBorder: selectedBorder,
    selectedHover: selectedHover
  })));
  var rootClasses = (0, _classnames.default)(classes.variables, classes.root, classes.colors, classes[size], _defineProperty({}, classes.shadowHover, shadow === "hover"), _defineProperty({}, classes.outlined, outlined), _defineProperty({}, classes.shadowOn, shadow === "on"), _defineProperty({}, classes.filled, filled), overrides.root, className);
  var svgIconClasses = (0, _classnames.default)(classes.svgIcon, overrides.svgIcon);
  var rootProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    className: rootClasses,
    disabled: disabled,
    ref: ref,
    type: "button"
  });
  return /*#__PURE__*/_react.default.createElement(Element, _extends({}, rootProps, {
    "aria-label": title !== null && title !== void 0 ? title : name
  }), /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
    name: name,
    size: iconSize || size,
    overrides: {
      root: svgIconClasses
    },
    viewBox: viewBox,
    fill: isTypeDefault(type) ? fill || type : type,
    title: title,
    dropShadow: dropShadow
  }));
});
var getColors = function getColors(type, colors, fill, isNewTheme, themeMode) {
  switch (type) {
    case "default":
      {
        var fillColor = fill ? colors[fill] || fill : null;
        if (!fill && isNewTheme && themeMode === _Theme.ThemeMode.light) {
          return {
            baseBorder: colors.baseContrast070,
            baseSvg: colors.baseContrast070,
            baseHover: colors.baseContrast085,
            selectedBorder: colors.primary,
            selectedSvg: colors.baseContrast100,
            selectedHover: colors.baseContrast100
          };
        }
        return {
          baseBorder: fillColor !== null && fillColor !== void 0 ? fillColor : colors.baseInvariant,
          baseSvg: fillColor !== null && fillColor !== void 0 ? fillColor : colors.baseInvariant,
          baseHover: colors.baseContrast100,
          selectedBorder: fillColor !== null && fillColor !== void 0 ? fillColor : colors.primary,
          selectedSvg: colors.baseContrast100,
          selectedHover: colors.baseContrast100
        };
      }
    case "error":
      {
        return {
          baseBorder: colors.baseInvariant,
          baseSvg: colors.baseInvariant,
          baseHover: colors.alert,
          selectedBorder: colors.alert,
          selectedSvg: colors.alert,
          selectedHover: (0, _getRgbaFromHex.default)(colors.alert, 0.75)
        };
      }
    case "highContrast":
      {
        return {
          baseBorder: isNewTheme ? colors.baseContrast070 : colors.baseContrast100,
          baseSvg: isNewTheme ? colors.baseContrast090 : colors.baseContrast100,
          baseHover: isNewTheme ? colors.baseContrast100 : colors.baseContrast070,
          selectedBorder: colors.primary,
          selectedSvg: colors.primary,
          selectedHover: colors.baseContrast100
        };
      }
    default:
      {
        var _colors$type;
        return {
          baseBorder: isNewTheme ? colors.baseContrast070 : colors.baseInvariant,
          baseSvg: isNewTheme ? colors.baseContrast070 : colors.baseInvariant,
          baseHover: colors[type],
          selectedBorder: colors[type],
          selectedSvg: colors[type],
          selectedHover: (0, _getRgbaFromHex.default)((_colors$type = colors[type]) !== null && _colors$type !== void 0 ? _colors$type : type, 0.75)
        };
      }
  }
};
var styles = function styles(_ref) {
  var colors = _ref.colors;
  return {
    variables: vars.styles,
    root: {
      backgroundColor: "transparent",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      outline: "none",
      border: 0,
      margin: 0,
      cursor: "pointer",
      userSelect: "none",
      verticalAlign: "middle",
      textDecoration: "none",
      textAlign: "center",
      borderRadius: "50%",
      boxSizing: "border-box",
      "&:disabled, &:disabled svg": {
        pointerEvents: "none",
        cursor: "default",
        fill: colors.baseContrast020,
        borderColor: colors.baseContrast020
      }
    },
    filled: {
      backgroundColor: colors.themeBase,
      "&:disabled": {
        backgroundColor: colors.baseContrast015
      }
    },
    outlined: {
      borderStyle: "solid",
      borderWidth: vars.get("borderWidth")
    },
    shadowOn: {
      boxShadow: "0 1px 2px 0 ".concat((0, _getRgbaFromHex.default)(colors.baseShadow, 0.5))
    },
    shadowHover: _objectSpread({}, (0, _getPseudoStyles.default)({
      hover: {
        boxShadow: "0 1px 2px 0 ".concat((0, _getRgbaFromHex.default)(colors.baseShadow, 0.5))
      }
    })),
    svgIcon: {
      display: "inline-block",
      verticalAlign: "middle"
    },
    colors: _objectSpread(_objectSpread({
      transitionDuration: TRANSITION_TIME,
      transitionProperty: ["box-shadow", "border-color"],
      borderColor: vars.get("colorsBorderColor"),
      "& svg": {
        transitionDuration: TRANSITION_TIME,
        transitionProperty: "fill",
        fill: vars.get("svgFill")
      }
    }, (0, _getPseudoStyles.default)({
      hover: {
        borderColor: vars.get("hoverColor"),
        "& svg": {
          fill: vars.get("hoverColor")
        }
      }
    })), {}, {
      "&:focus-visible": {
        borderColor: vars.get("selectedBorder"),
        "& svg": {
          fill: vars.get("selectedHover")
        }
      }
    })
  };
};
var useStyles = (0, _createUseStyles.default)(styles, {
  name: "IconButton"
});
IconButton.displayName = "IconButton";
var Storybook = exports.Storybook = IconButton;

/**
 * @see https://icfreactcomponents.integ.icfsys.com/?path=/docs/action-iconbutton--docs
 */
var exportedComponent = (0, _createPolymorphicComponent.default)((0, _defaultProps.default)(IconButton));
exportedComponent.displayName = "IconButton";
var _default = exports.default = exportedComponent;